// extracted by mini-css-extract-plugin
module.exports = {"v-list__tile":"ListView_v-list__tile_1Q5VD","copiedSnacksBar":"ListView_copiedSnacksBar_KmkEN"};